import axios from '@/axios'

export default {
  getPrabayar (options) {
    return axios.get('/price-prepaid', options)
  },
  savePostpaid(payload, options) {
    return axios.post('/input/ppob', payload, options)
  }
}